import React from 'react'
import { useTranslation } from 'react-i18next'
import AnalyticSeriesChart, {
    AnalyticSeriesData,
} from '../../../shared/AnalyticSeriesChart'

interface VMSUsageChartProps {
    data?: AnalyticSeriesData
}

// VMS transcoding storage usage (GB). Single-metric time series from the
// margarita-backed endpoint (type=/vms_transcoding_usage).
const VMSUsageChart: React.FC<VMSUsageChartProps> = ({ data }) => {
    const { t } = useTranslation()
    return (
        <AnalyticSeriesChart
            data={data}
            title={t('services.vms-transcoding-usage')}
            unit="GB"
            color="#10b981"
            variant="bar"
            totalLabel="Total GB"
            emptyText="No VMS usage data available for the selected period"
        />
    )
}

export default VMSUsageChart
